import styled, {createGlobalStyle} from 'styled-components';
import LSCCondensedWoff from '../static/font/LSCCondensed.woff';
import LSCCondensedWoff2 from '../static/font/LSCCondensed.woff2';
import LSCCondensedItalicWoff from '../static/font/LSCCondensedItalic.woff';
import LSCCondensedItalicWoff2 from '../static/font/LSCCondensedItalic.woff2';

export const GlobalStyle = createGlobalStyle`
    @font-face{
        font-family:LSCCondensed;
        src:url(${LSCCondensedWoff});
        src:url(${LSCCondensedWoff}) format("woff"),
            url(${LSCCondensedWoff2}) format("woff2");
        font-style:normal;
    }
    @font-face{
        font-family:LSCCondensed;
        src:url(${LSCCondensedItalicWoff});
        src:url(${LSCCondensedItalicWoff}) format("woff"),
            url(${LSCCondensedItalicWoff2}) format("woff2");
        font-style:italic;
    }
    html, body {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        font-family: futura-pt;
        scroll-behavior: auto;
    }
    body {
        overflow-x: hidden;
    }
    h1, h2, h3, h4, h5, h6 {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
        display: inherit;
    }
    * {
        color: black;
        overflow-x: visible;
    }
`;

export const Main = styled.div`
    width: 100%;
    height: 100%;
`;